<template>
  <div>
    <PageHeaderLayout :isBack="true">
      <div class="main-page-content edit-amount-page" v-loading="loading">
        <div class="page-title">修改金额</div>
        <div class="content-card">
          <div class="content-grid">
            <div class="info-column">
              <div class="info-item">
                <span class="label">姓名</span>
                <span class="value">{{ getDisplayValue(detailInfo.bank_account_name) }}</span>
              </div>
              <div class="info-item">
                <span class="label">身份证号码</span>
                <span class="value">{{ getDisplayValue(detailInfo.id_number) }}</span>
              </div>
              <div class="info-item">
                <span class="label">手机号码</span>
                <span class="value">{{ getDisplayValue(detailInfo.mobile) }}</span>
              </div>
              <div class="info-item">
                <span class="label">收款账号</span>
                <span class="value">{{ getDisplayValue(detailInfo.bank_account_no) }}</span>
              </div>
              <div class="info-item">
                <span class="label">下发通道</span>
                <span class="value">{{ getDisplayValue(channelText) }}</span>
              </div>
              <div class="info-item">
                <span class="label">实收金额</span>
                <span class="value">{{ getDisplayValue(detailInfo.after_money) }}</span>
              </div>
            </div>

            <div class="info-column">
              <div class="info-item">
                <span class="label">银行名称</span>
                <span class="value">{{ getDisplayValue(detailInfo.bank_name) }}</span>
              </div>
              <div class="info-item">
                <span class="label">开户行名称</span>
                <span class="value">{{ getDisplayValue(detailInfo.bank_branch) }}</span>
              </div>
              <div class="info-item">
                <span class="label">累计打卡天数</span>
                <span class="value">{{ totalClockDaysText }}</span>
              </div>
              <div class="info-item">
                <span class="label">累计工时</span>
                <span class="value">{{ totalWorkHoursText }}</span>
              </div>

              <div class="form-row">
                <span class="label">结算方式</span>
                <el-select
                  v-model="form.salary_type"
                  placeholder="请选择"
                  class="input-control"
                  @change="handleSalaryTypeChange"
                >
                  <el-option
                    v-for="item in salaryTypeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>

              <div v-if="showUnitAmountInput" class="form-row">
                <span class="label">{{ currentSalaryLabel }}</span>
                <el-input
                  v-model.trim="form.unit_amount"
                  class="input-control"
                  @input="handleUnitAmountChange"
                >
                  <template slot="append">{{ currentSalaryUnit }}</template>
                </el-input>
              </div>

              <div class="form-row">
                <span class="label">结算金额</span>
                <el-input
                  v-model.trim="form.settlement_amount"
                  class="input-control"
                >
                  <template slot="append">元</template>
                </el-input>
              </div>
            </div>
          </div>

          <div class="submit-row">
            <el-button type="primary" @click="handleSave">保存</el-button>
          </div>
        </div>
      </div>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import { SALARY_TYPE_LIST } from "@/utils/utils";

const SEED_PREFIX = "dailySettlementAmountSeed";
const OVERRIDE_PREFIX = "dailySettlementAmountOverride";
const SALARY_LABEL_MAP = {
  1: "每天金额",
  2: "每周金额",
  3: "每月金额",
  6: "小时金额",
};
const SALARY_UNIT_MAP = {
  1: "元/天",
  2: "元/周",
  3: "元/月",
  6: "元/小时",
};

export default {
  components: {
    PageHeaderLayout,
  },
  data() {
    return {
      loading: false,
      batchId: "",
      detailId: "",
      baseInfo: {},
      detailInfo: {},
      salaryTypeOptions: SALARY_TYPE_LIST,
      form: {
        salary_type: "",
        unit_amount: "",
        settlement_amount: "",
      },
    };
  },
  computed: {
    showUnitAmountInput() {
      return [1, 2, 3, 6].includes(Number(this.form.salary_type));
    },
    currentSalaryLabel() {
      return SALARY_LABEL_MAP[Number(this.form.salary_type)] || "金额";
    },
    currentSalaryUnit() {
      return SALARY_UNIT_MAP[Number(this.form.salary_type)] || "元";
    },
    channelText() {
      const channel = this.detailInfo.yl_bank || this.baseInfo.yl_bank || this.detailInfo.send_type;
      const textMap = {
        alipay: "支付宝",
        pingan: "银行",
        sj: "银行",
        wechat: "微信",
        ws: "银行",
        wssft: "银行",
        OTHERBANK: "银行卡",
        ALIPAY: "支付宝",
      };
      return textMap[channel] || channel || "-";
    },
    totalClockDaysText() {
      const value = this.resolveMetricValue([
        "clock_days",
        "clock_day_num",
        "attendance_days",
        "check_days",
        "total_days",
        "day_num",
      ]);
      return value === "" ? "-" : `${value}天`;
    },
    totalWorkHoursText() {
      const value = this.resolveMetricValue([
        "work_hours",
        "clock_hours",
        "attendance_hours",
        "hour_num",
        "total_hours",
      ]);
      return value === "" ? "-" : `${value}小时`;
    },
  },
  methods: {
    getDisplayValue(value) {
      return value === undefined || value === null || value === "" ? "-" : value;
    },
    getSeedStorageKey() {
      return `${SEED_PREFIX}:${this.batchId}:${this.detailId}`;
    },
    getOverrideStorageKey() {
      return `${OVERRIDE_PREFIX}:${this.batchId}:${this.detailId}`;
    },
    getRecordIdentity(record = {}) {
      return (
        record.id ||
        record.detail_id ||
        record.customer_id ||
        record.user_id ||
        record.id_number ||
        ""
      );
    },
    formatAmount(value) {
      if (value === "" || value === null || value === undefined) {
        return "";
      }
      const num = Number(value);
      if (Number.isNaN(num)) {
        return "";
      }
      return num.toFixed(2).replace(/\.?0+$/, "");
    },
    toNumber(value) {
      const num = Number(value);
      return Number.isNaN(num) ? 0 : num;
    },
    resolveMetricValue(keys = []) {
      for (let i = 0; i < keys.length; i += 1) {
        const key = keys[i];
        const detailValue = this.detailInfo[key];
        if (detailValue !== undefined && detailValue !== null && detailValue !== "") {
          return detailValue;
        }
        const baseValue = this.baseInfo[key];
        if (baseValue !== undefined && baseValue !== null && baseValue !== "") {
          return baseValue;
        }
      }
      return "";
    },
    getCountFactorBySalaryType(salaryType) {
      const totalDays = this.toNumber(
        this.resolveMetricValue([
          "clock_days",
          "clock_day_num",
          "attendance_days",
          "check_days",
          "total_days",
          "day_num",
        ])
      );
      const totalHours = this.toNumber(
        this.resolveMetricValue([
          "work_hours",
          "clock_hours",
          "attendance_hours",
          "hour_num",
          "total_hours",
        ])
      );
      const factorMap = {
        1: totalDays,
        2: totalDays / 7,
        3: totalDays / 30,
        6: totalHours,
      };
      return factorMap[Number(salaryType)] || 0;
    },
    getDefaultSalaryType() {
      const override = this.getSavedOverride();
      if (override && override.salary_type) {
        return Number(override.salary_type);
      }
      const salaryType = this.detailInfo.salary_type || this.baseInfo.salary_type;
      return salaryType ? Number(salaryType) : "";
    },
    getBaseSalaryAmount() {
      return (
        this.detailInfo.min_salary ||
        this.baseInfo.min_salary ||
        this.detailInfo.money ||
        this.baseInfo.total_amount ||
        ""
      );
    },
    getSavedOverride() {
      const rawValue = window.sessionStorage.getItem(this.getOverrideStorageKey());
      if (!rawValue) {
        return null;
      }
      try {
        return JSON.parse(rawValue);
      } catch (error) {
        return null;
      }
    },
    getSeedData() {
      const rawValue = window.sessionStorage.getItem(this.getSeedStorageKey());
      if (!rawValue) {
        return null;
      }
      try {
        return JSON.parse(rawValue);
      } catch (error) {
        return null;
      }
    },
    deriveUnitAmountBySalaryType(salaryType, settlementAmount) {
      const directFieldMap = {
        1: ["day_money", "daily_money"],
        2: ["week_money", "weekly_money"],
        3: ["month_money", "monthly_money"],
        6: ["hour_money", "hourly_money"],
      };
      const fields = directFieldMap[Number(salaryType)] || [];
      for (let i = 0; i < fields.length; i += 1) {
        const fieldValue = this.detailInfo[fields[i]];
        if (fieldValue !== undefined && fieldValue !== null && fieldValue !== "") {
          return this.formatAmount(fieldValue);
        }
      }

      const factor = this.getCountFactorBySalaryType(salaryType);
      if (factor > 0 && settlementAmount !== "") {
        return this.formatAmount(this.toNumber(settlementAmount) / factor);
      }
      return this.formatAmount(this.baseInfo.min_salary || "");
    },
    initFormData() {
      const override = this.getSavedOverride();
      const salaryType = this.getDefaultSalaryType();
      const settlementAmount =
        (override && override.settlement_amount) ||
        this.detailInfo.money ||
        this.getBaseSalaryAmount();

      this.form.salary_type = salaryType;
      this.form.settlement_amount = this.formatAmount(settlementAmount);
      this.form.unit_amount = this.showUnitAmountInput
        ? (override && override.unit_amount) ||
          this.deriveUnitAmountBySalaryType(salaryType, settlementAmount)
        : "";

      if ([4, 5].includes(Number(this.form.salary_type)) && !this.form.settlement_amount) {
        this.form.settlement_amount = this.formatAmount(this.getBaseSalaryAmount());
      }
    },
    handleSalaryTypeChange(value) {
      const salaryType = Number(value);
      if ([4, 5].includes(salaryType)) {
        this.form.unit_amount = "";
        if (!this.form.settlement_amount) {
          this.form.settlement_amount = this.formatAmount(this.getBaseSalaryAmount());
        }
        return;
      }

      this.form.unit_amount = this.deriveUnitAmountBySalaryType(
        salaryType,
        this.form.settlement_amount
      );
      this.refreshSettlementAmount();
    },
    handleUnitAmountChange() {
      this.refreshSettlementAmount();
    },
    refreshSettlementAmount() {
      if (!this.showUnitAmountInput) {
        return;
      }
      const unitAmount = this.toNumber(this.form.unit_amount);
      if (!unitAmount) {
        return;
      }
      const factor = this.getCountFactorBySalaryType(this.form.salary_type);
      if (!factor) {
        return;
      }
      this.form.settlement_amount = this.formatAmount(unitAmount * factor);
    },
    validateForm() {
      if (!this.form.salary_type) {
        this.$message.error("请选择结算方式");
        return false;
      }
      if (this.showUnitAmountInput) {
        if (this.form.unit_amount === "") {
          this.$message.error(`请输入${this.currentSalaryLabel}`);
          return false;
        }
        if (this.toNumber(this.form.unit_amount) <= 0) {
          this.$message.error(`${this.currentSalaryLabel}必须大于0`);
          return false;
        }
      }
      if (this.form.settlement_amount === "") {
        this.$message.error("请输入结算金额");
        return false;
      }
      if (this.toNumber(this.form.settlement_amount) <= 0) {
        this.$message.error("结算金额必须大于0");
        return false;
      }
      return true;
    },
    goBack() {
      const from = this.$route.query.from || "view";
      this.$router.push(`${this.$route.matched[1].path}/${this.batchId}/${from}`);
    },
    async init() {
      this.batchId = this.$route.params.batch_id;
      this.detailId = this.$route.params.detail_id;
      if (!this.batchId || !this.detailId) {
        this.$message.error("缺少批次信息");
        this.goBack();
        return;
      }

      const seedData = this.getSeedData();
      if (seedData) {
        this.baseInfo = seedData.baseInfo || {};
        this.detailInfo = seedData.detailInfo || {};
      }

      this.loading = true;
      try {
        const { base, detail } = await this.$api.getTaskInfo({
          id: this.batchId,
        });
        this.baseInfo = base || this.baseInfo;
        if (Array.isArray(detail) && detail.length) {
          const currentDetail = detail.find((item) => {
            const currentId = this.getRecordIdentity(item);
            return String(currentId) === String(this.detailId);
          });
          if (currentDetail) {
            this.detailInfo = currentDetail;
          }
        }
      } finally {
        this.initFormData();
        this.loading = false;
      }
    },
    handleSave() {
      if (!this.validateForm()) {
        return;
      }

      const payload = {
        batch_id: this.batchId,
        detail_id: this.detailId,
        salary_type: Number(this.form.salary_type),
        unit_amount: this.showUnitAmountInput ? this.formatAmount(this.form.unit_amount) : "",
        settlement_amount: this.formatAmount(this.form.settlement_amount),
      };
      window.sessionStorage.setItem(this.getOverrideStorageKey(), JSON.stringify(payload));
      this.$message.success("保存成功");
      this.goBack();
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.edit-amount-page {
  padding: 0;
}

.page-title {
  height: 53px;
  line-height: 53px;
  background: #1890ff;
  color: #fff;
  font-size: 20px;
  text-align: center;
}

.content-card {
  padding: 28px 36px 18px;
  background: #fff;
}

.content-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 48px;
}

.info-column {
  min-width: 0;
}

.info-item,
.form-row {
  display: flex;
  align-items: center;
  margin-bottom: 22px;
  min-height: 40px;
}

.label {
  width: 110px;
  font-size: 18px;
  font-weight: 700;
  color: #1f1f1f;
  flex-shrink: 0;
}

.value {
  flex: 1;
  color: #909399;
  font-size: 16px;
  word-break: break-all;
}

.input-control {
  width: 260px;
}

.submit-row {
  display: flex;
  justify-content: center;
  margin-top: 18px;
}

@media screen and (max-width: 1200px) {
  .content-grid {
    grid-template-columns: 1fr;
    row-gap: 4px;
  }
}
</style>
